import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Eye, Users, GraduationCap, Baby, School, Settings } from "lucide-react";

interface ViewOption {
  label: string;
  route: string;
  icon: React.ReactNode;
  description: string;
}

const viewOptions: ViewOption[] = [
  {
    label: "Admin Dashboard",
    route: "/admin",
    icon: <Settings className="h-4 w-4" />,
    description: "Platform management & analytics",
  },
  {
    label: "Parent View",
    route: "/parent",
    icon: <Users className="h-4 w-4" />,
    description: "Family progress tracking",
  },
  {
    label: "Student View",
    route: "/student",
    icon: <GraduationCap className="h-4 w-4" />,
    description: "Learning dashboard",
  },
  {
    label: "Kid View",
    route: "/learn",
    icon: <Baby className="h-4 w-4" />,
    description: "Interactive kid experience",
  },
  {
    label: "Teacher View",
    route: "/teacher",
    icon: <School className="h-4 w-4" />,
    description: "Class management",
  },
];

export const DashboardViewSwitcher = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentView = viewOptions.find((option) => 
    location.pathname.startsWith(option.route)
  ) || viewOptions[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <Eye className="h-4 w-4" />
          <span className="hidden sm:inline">View As:</span>
          <span className="font-semibold">{currentView.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72 bg-popover/95 backdrop-blur supports-[backdrop-filter]:bg-popover/95">
        <DropdownMenuLabel className="text-base">Switch Dashboard View</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {viewOptions.map((option) => (
          <DropdownMenuItem
            key={option.route}
            onClick={() => navigate(option.route)}
            className={`cursor-pointer flex items-start gap-3 py-3 ${
              location.pathname.startsWith(option.route)
                ? "bg-secondary text-secondary-foreground"
                : ""
            }`}
          >
            <div className="mt-0.5">{option.icon}</div>
            <div className="flex-1">
              <div className="font-medium">{option.label}</div>
              <div className="text-xs text-muted-foreground">{option.description}</div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
